export class LoginUser{

    Username : string = "";
    Password : string = "";

}

export default LoginUser; 